import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Logo from '../../common/components/Logos/Logo';
import { LogoSize } from '../../common/components/Logos/logos-types';
import GitHubLogo from '../../common/components/Logos/social/GitHubLogo';
import LinkedinLogo from '../../common/components/Logos/social/LinkedinLogo';
import YoutubeLogo from '../../common/components/Logos/social/YoutubeLogo';
import WebLogo from '../../common/components/Logos/local/WebLogo';
import Switch from '../../common/components/Switch/Switch';
import useTheme from '../../common/hooks/useTheme';
import { Theme, ThemeLogos } from '../../common/reducers/theme/theme-types';
import Link from '../../common/components/Link/Link';
import selectVisiblePage from '../../common/reducers/visible-page/visible-page-selectors';
import URL from '../../common/types/url-types';
var Sidebar = function () {
    var _a = useTheme(), toggleTheme = _a.toggleTheme, theme = _a.theme;
    var _b = useState('HOME'), page = _b[0], setPage = _b[1];
    var _c = useState(null), animation = _c[0], setAnimation = _c[1];
    var visiblePage = useSelector(selectVisiblePage());
    useEffect(function () {
        if (visiblePage !== page) {
            setTimeout(function () {
                setAnimation('animate-in');
                setPage(visiblePage);
            }, 200);
            setAnimation('animate-out');
        }
    }, [visiblePage]);
    return (React.createElement("aside", { className: 'sidebar' },
        React.createElement("section", { className: 'sidebar__logo' },
            React.createElement(Logo, { size: LogoSize.BIG, image: WebLogo })),
        React.createElement("section", { className: "sidebar__visible-page ".concat(animation) }, visiblePage),
        React.createElement("section", { className: 'sidebar__section' },
            React.createElement(Link, { href: URL.LINKEDIN },
                React.createElement(Logo, { size: LogoSize.SMALL, image: LinkedinLogo })),
            React.createElement(Link, { href: URL.YOUTUBE },
                React.createElement(Logo, { size: LogoSize.SMALL, image: YoutubeLogo })),
            React.createElement(Link, { href: URL.GITHUB },
                React.createElement(Logo, { size: LogoSize.SMALL, image: GitHubLogo })),
            React.createElement(Switch, { onClick: function () { return toggleTheme(); }, checked: theme === Theme.LIGHT, checkedIcon: ThemeLogos.LIGHT, uncheckedIcon: ThemeLogos.DARK }))));
};
export default Sidebar;
